var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("IXP internet services")]),_c('p',[_vm._v("No more hanging please!")]),_c('p',[_vm._v("Really?!")]),_c('p',[_vm._v("Yes indeed!")]),_c('p',[_vm._v("Now it is "+_vm._s(_vm.currenttime))])])}
var staticRenderFns = []

export { render, staticRenderFns }